<div>
  <h1 class="header col-12 mb-2">
    Annuity Book Management <span>- Rep View</span>
  </h1>

  <app-bm-widget-filters [viewMode]="'rep'" />

  <div class="home-office-container">
    <div class="row">
      <app-contract-stats
        class="col-12"
        [reportName]="'PM Rep Contract Totals'"
      />
    </div>

    <div class="row">
      <app-contract-summary
        class="col-12"
        [reportName]="'PM Rep Contract Summary'"
        [headerType]="'rep'"
      />
    </div>

    @if (showPolicyReview || showPolicyTags) {
      <div class="row">
        @if (showPolicyReview) {
          <app-top-performers
            [ngClass]="{
              'col-6': showPolicyTags,
              'col-12': !showPolicyTags,
            }"
            [title]="'Policy Review Relevance'"
            [configType]="'rep-top-policy-review'"
            [reportName]="'PM Rep Top Policy Review'"
          />
        }
        @if (showPolicyTags) {
          <app-policy-alerts
            [ngClass]="{
              'col-6': showPolicyReview,
              'col-12': !showPolicyReview,
            }"
            [configType]="'rep-policy-alerts'"
            [reportName]="'PM Rep Policy Alerts'"
            [headerType]="'rep'"
          />
        }
      </div>
    }
  </div>
</div>
